function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M110.806 43.1412L72.5756 39.9573C68.815 39.6441 65.0329 39.6923 61.2814 40.1012L16.337 45H16.307C13.3668 45 11.7075 41.6241 13.5033 39.2962C17.408 34.2345 15.3275 26.8399 9.35634 24.5568L6.99956 23.6557C4.59251 22.7353 3.16692 20.2468 3.59058 17.7048L4.54576 11.9737C4.81026 10.3867 6.67465 9.65864 7.94463 10.6464C12.7755 14.4037 19.8688 11.6726 20.9324 5.64564L21.006 5.22862C21.3063 3.52691 23.2634 2.70298 24.6904 3.6775L34.0778 10.0884C37.7901 12.6236 42.8628 11.5946 45.2937 7.81319C46.2326 6.35257 48.4626 6.71972 48.8837 8.40427L51.8105 20.1113C53.1899 25.6291 58.1477 29.5 63.8353 29.5H70.9494C79.0965 29.5 83.3138 19.775 77.7458 13.8275C75.6214 11.5582 77.5138 7.87694 80.5955 8.28395L88.6332 9.34554C89.4916 9.45891 90.3596 9.48065 91.2225 9.41041L110.839 7.81375C121.16 6.97365 130 15.1234 130 25.4788C130 35.8474 121.138 44.0017 110.806 43.1412Z",
  stroke: "currentColor",
  strokeWidth: 6
});

function SvgTrack6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 48,
    viewBox: "0 0 133 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrack6);
export default __webpack_public_path__ + "static/media/track6.099c3c8a.svg";
export { ForwardRef as ReactComponent };